export const GUIDES = [
  {
    title: "Get started with Zapier Canvas",
    description:
      "Discover the essentials, from creating and connecting steps, to organizing your workflows.",
    url: "https://help.zapier.com/hc/en-us/articles/19880280846221-Create-a-canvas-to-visualize-your-automated-system",
  },
  {
    title: "Build a complete system with AI prompts",
    description:
      "Learn how to use prompts to generate entire systems effortlessly with Canvas AI.",
    url: "https://help.zapier.com/hc/en-us/articles/33905788806029-Prompt-AI-to-create-a-system-in-Zapier-Canvas",
  },
  {
    title: "Ask AI to suggest a new step",
    description:
      "Learn how to use Smart Steps Recommendations to build your automated systems.",
    url: "https://help.zapier.com/hc/en-us/articles/33905977592205-Ask-AI-to-suggest-a-new-step-for-your-canvas",
  },
];

export const ALL_GUIDES_URL =
  "https://help.zapier.com/hc/en-us/categories/19840274478093-Canvas";
